import React from 'react'
import WorkWithUs from '../fetures/work-with-us/WorkWithUs'

const WorkWithUsPage = () => {
  return (
    <WorkWithUs/>
  )
}

export default WorkWithUsPage